// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__3rFw8","nav":"Navbar_nav__10_iK","background":"Navbar_background__2hohs"};